import React from 'react';
import './Button.css';

export const Button = ({ classes, title, onClick, style, invisible, disabled, icon }) => {
    return (
        <button
            type="button"
            style={style}
            className={`${classes} ${invisible ? 'invisible' : ''}`}
            onClick={onClick}
            disabled={disabled}
        >
            {title ? title : ''}
            {icon ? icon : ''}
        </button>
    );
};
